// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1MQLd","productName":"Table_productName__1J7T8"};